import React, { useEffect, useState } from "react";
import InnerTitle2 from "../../components/InnerTitle2";
import { cmsPage } from "../../services/cms.service";
import { renderCmsContent } from "../../../../utils/commonfunction";

function AboutUs() {
  const [cmsData, setCmsData] = useState(null);

  useEffect(() => {
    cmsPage({ slug: "about-us" })
      .then((response) => {
        if (response.success) {
          setCmsData(response.data); // save CMS data
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <div className="about-bg py-10 pt-0">
        <InnerTitle2 title={cmsData?.title || "About Us"} />

        <div className="about-content-bg">
          {/* Hero Section */}
          <section className="py-10 lg:py-16 text-center">
            <div className="container">


              {/* Replace static lorem text with CMS HTML */}
              <div
                className="max-w-4xl mx-auto body-lg text-gray-600 !leading-relaxed text-left"
                dangerouslySetInnerHTML={{
                  __html: renderCmsContent(cmsData?.description),
                }}></div>

              {/* Image Placeholder */}
              
            </div>
          </section>

          {/* Mission Section */}
          <section className="">
            <div className="grid grid-cols-1 lg:grid-cols-1">
              {/* Left Panel */}
              <div className="bg-primary-400 p-4 sm:p-16 text-white flex flex-col justify-center">
                <div className="max-w-[568px] m-auto">
                  <h2 className="text-3xl font-semibold mb-6">Our Mission</h2>

                  <p className="mb-4 body-lg text-white !leading-relaxed">Our mission is to empower sellers with tools to connect directly with customers, and to give shoppers a transparent, entertaining, and interactive shopping experience.</p>
                  <p className="mb-4 body-lg text-white !leading-relaxed">We started with a vision to make online shopping more personal and trustworthy.</p>
                  <p className="mb-4 body-lg text-white !leading-relaxed">Our mission is to empower sellers with tools to connect directly with customers, and to give shoppers a transparent, entertaining experience.</p>
                </div>
              </div>

             
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
